import React from 'react';
import { C, DISP, BODY, MONO, FadeUp, Kicker, SectionH2, SectionSub, SECTION_PAD, useSectionView } from './shared';

const GROUPS = [
  {
    step: 'Outcome 1',
    title: 'Know what to do',
    body: 'Stop guessing. ScalitOS ranks your options and hands you the highest-impact next move.',
    items: ['Daily Growth Plan, ranked by impact', 'Weekly strategy with a clear focus', 'Brand health score', 'Competitor scans on live website data', 'Opportunities spotted for you'],
  },
  {
    step: 'Outcome 2',
    title: 'Get it created',
    body: 'Every asset the plan calls for, written and designed in your brand voice.',
    items: ['Social posts and carousels', 'Emails and campaign copy', 'Ad creative, visuals and video', 'Landing pages', 'Full campaign asset sets'],
  },
  {
    step: 'Outcome 3',
    title: 'Stay consistent and improve',
    body: 'The system remembers what you did and gets sharper every week.',
    items: ['Marketing calendar', 'Campaign workspace', 'Campaign analytics', 'Weekly review', 'Strategic memory that shapes the next recommendation'],
  },
];

export const OutcomesSection = () => {
  const ref = useSectionView('outcomes');
  return (
    <section id="outcomes" ref={ref} style={{ padding: SECTION_PAD }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <FadeUp><Kicker>What you get</Kicker></FadeUp>
        <FadeUp delay={80}>
          <SectionH2>
            One system.<br />
            <span style={{ color: 'rgba(242,245,234,0.45)' }}>Three jobs done.</span>
          </SectionH2>
        </FadeUp>
        <FadeUp delay={140}>
          <SectionSub>
            ScalitOS is not a pile of disconnected tools. It does the three things a marketing team would do for you.
          </SectionSub>
        </FadeUp>

        <div style={{ marginTop: 56, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(300px, 100%), 1fr))', gap: 18 }}>
          {GROUPS.map((g, i) => (
            <FadeUp key={i} delay={i * 100}>
              <div className="scl-card" style={{ padding: '32px 28px', border: `1px solid ${C.border}`, borderRadius: 18, background: C.surface, height: '100%', display: 'flex', flexDirection: 'column' }}>
                <p style={{ fontFamily: MONO, fontSize: 10, letterSpacing: '0.22em', color: C.lime, textTransform: 'uppercase', marginBottom: 14 }}>{g.step}</p>
                <p style={{ fontFamily: DISP, fontWeight: 800, fontSize: 24, color: C.text, letterSpacing: '-0.01em', marginBottom: 12 }}>{g.title}</p>
                <p style={{ fontFamily: BODY, fontSize: 14.5, lineHeight: 1.7, color: C.body, marginBottom: 22 }}>{g.body}</p>
                <div style={{ marginTop: 'auto' }}>
                  {g.items.map((it, j) => (
                    <div key={j} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 }}>
                      <span aria-hidden="true" style={{ color: C.lime, fontSize: 13, marginTop: 2, fontFamily: MONO }}>&#10003;</span>
                      <p style={{ fontFamily: BODY, fontSize: 14, color: C.body, lineHeight: 1.6 }}>{it}</p>
                    </div>
                  ))}
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
